import React from 'react'
import { Profile } from '@news-mono/web-common'
import { scaleImage } from '@news-mono/web-common'
import {
    StyledHeadshotWrapper,
    StyledHeadshot,
    StyledHeadshotAmp,
} from '../Byline.styled'
import { createRenderTarget } from '../../../render-target'

export const ProfileImageResSize = 110
export const ProfileImageDisplaySize = 53

interface BylineProfileProps {
    profile: Profile[]
}

export const BylineProfile: React.FC<BylineProfileProps> = ({ profile }) => {
    const profileImage = getProfileImage(profile)

    if (!profileImage) {
        return null
    }

    return (
        <StyledHeadshotWrapper>
            <Headshot
                source={profileImage}
                alt={profile[0] ? `Headshot of ${profile[0].name}` : undefined}
            />
        </StyledHeadshotWrapper>
    )
}

interface HeadshotProps {
    source: string
    alt: string | undefined
}

const Headshot = createRenderTarget<HeadshotProps>('Headshot', {
    web: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
    amp: ({ alt, source }) => (
        <StyledHeadshotAmp
            width={ProfileImageDisplaySize}
            height={ProfileImageDisplaySize}
            alt={alt}
            src={source}
        />
    ),
    rss: ({ alt, source }) => <img src={source} alt={alt} />,
    preview: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
    app: ({ alt, source }) => <StyledHeadshot alt={alt} src={source} />,
})
Headshot.displayName = 'Headshot'

function getProfileImage(profiles: Profile[]): string | undefined {
    for (const profile of profiles) {
        if (profile.thumbnailPhoto) {
            return scaleImage(profile.thumbnailPhoto, ProfileImageResSize)
        }
    }

    return undefined
}
